import { http } from '../request'
import {
  type ManagementImportResult,
  normalizeListResponse,
  normalizePageResponse
} from './shared'

export interface StaffPositionInfo {
  positionId: number
  positionName: string
  /** 管辖年级ID（仅年级组长岗位有值） */
  gradeId?: number
  scopeType?: string
  classIds?: number[]
}

export interface StaffDto {
  id: number
  staffNo?: string
  name: string
  gender: string
  phone?: string
  departmentId?: number
  departmentName?: string
  isTeachingStaff?: boolean
  employmentStatus: string
  hireDate?: string
  leaveDate?: string
  hasAccount: boolean
  userId?: number
  roleIds?: number[]
  positions: StaffPositionInfo[]
  /** 是否担任班主任（来自班级事实，只读） */
  headTeacher?: boolean
  username?: string | null
}

type StaffPageResponse = {
  items: StaffDto[]
  total: number
  page: number
  pageSize: number
}

export const staffApi = {
  async list(params?: Record<string, unknown>): Promise<StaffPageResponse> {
    const response = await http.get<StaffPageResponse>('/data-management/staff', params)
    return normalizePageResponse<StaffDto>(response.data)
  },
  async create(payload: Partial<StaffDto> & Record<string, unknown>): Promise<StaffDto> {
    const response = await http.post<StaffDto>('/data-management/staff', payload)
    return response.data
  },
  async update(id: number, payload: Partial<StaffDto> & Record<string, unknown>): Promise<StaffDto> {
    const response = await http.put<StaffDto>(`/data-management/staff/${id}`, payload)
    return response.data
  },
  async remove(id: number): Promise<void> {
    await http.delete<void>(`/data-management/staff/${id}`)
  },
  async batchRemove(ids: number[]): Promise<void> {
    await http.post<void>('/data-management/staff/batch-delete', { ids })
  },
  async batchUpdateStatus(ids: number[], status: string): Promise<number> {
    const response = await http.post<number>('/data-management/staff/batch-update-status', { ids, status })
    return response.data
  },
  async importRows(rows: unknown[]): Promise<ManagementImportResult> {
    const response = await http.post<ManagementImportResult>(
      '/data-management/staff/import',
      rows
    )
    return response.data
  },
  async listTeachingStaff(): Promise<StaffDto[]> {
    const response = await http.get<StaffDto[]>('/data-management-lookup/staff/teaching')
    return normalizeListResponse<StaffDto>(response.data)
  },
  async checkNameDuplicate(name: string, excludeId?: number): Promise<boolean> {
    const response = await http.get<boolean>('/data-management/staff/check-name', { name, excludeId })
    return Boolean(response.data)
  }
}
